import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewMode } from '../../shared/model/relatorio-custo.models';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-relatorio-header',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './relatorio-header.component.html',
  styleUrls: ['./relatorio-header.component.css'],
})
export class RelatorioHeaderComponent {
  @Input({ required: true }) anos!: number[];
  @Input({ required: true }) anoSelecionado!: number;
  @Input({ required: true }) viewMode!: ViewMode;
  @Input() metaToggle = false;

  @Output() anoChange = new EventEmitter<number>();
  @Output() viewModeChange = new EventEmitter<ViewMode>();
  @Output() metaToggleChange = new EventEmitter<boolean>();

  setAno(v: string) {
    const ano = Number(v);
    if (!Number.isNaN(ano)) this.anoChange.emit(ano);
  }

  setMode(mode: ViewMode) {
    this.viewModeChange.emit(mode);
  }

  toggleMeta() {
    this.metaToggleChange.emit(!this.metaToggle);
  }
}
